import React, {useState} from 'react';
import {useIntl} from 'react-intl';
import PropTypes from 'prop-types';

import {Button, Table} from 'antd';
import MethodInfo from './MethodInfo';

const MethodList = (props) => {
  const intl = useIntl();

  const {practitioner} = props;
  const [selectedMethod, setSelectedMethod] = useState();
  const [viewing, setViewing] = useState(false);

  const onView = (method) => {
    setSelectedMethod(method);
    setViewing(true);
  };

  const columns = [
    {
      title: intl.messages['practitioner.method.treatment'],
      dataIndex: 'treatment',
      key: 'treatment',
      render: (treatment, record) => (
        <Button type='link' onClick={() => onView(record)}>
          {treatment}
        </Button>
      ),
    },
    {
      title: intl.messages['practitioner.method'],
      dataIndex: 'method',
      key: 'method',
    },
    {
      title: intl.messages['practitioner.method.result'],
      dataIndex: 'result',
      key: 'result',
    },
  ];

  return (
    <>
      <Table
        columns={columns}
        dataSource={practitioner?.methods}
        rowKey={(record) => record.treatment}
        pagination={false}
        scroll={{x: 'auto'}}
      />

      <MethodInfo
        selectedMethod={selectedMethod}
        viewing={viewing}
        setViewing={setViewing}
      />
    </>
  );
};

export default MethodList;

MethodList.propTypes = {
  practitioner: PropTypes.object,
};
